export const categories = {
	basicNeeds: 0,
	humanRights: 1,
	education: 2,
	emergency: 3,
	feeding: 4,
	environment: 5,
	habitat: 6,
	health: 7,
} as const;

export const categoriesKeys = [
	'basicNeeds',
	'humanRights',
	'education',
	'emergency',
	'feeding',
	'environment',
	'habitat',
	'health',
] as const;

export type CategoryKey = (typeof categoriesKeys)[number];

export type Category = (typeof categories)[keyof typeof categories];

export const beneficiaryTypes = [
	'children',
	'youth',
	'elderly',
	'women',
	'men',
	'lgbtiq',
	'disabilities',
	'refugees',
	'homeless',
	'animals',
	'ecosystems',
] as const;

export type BeneficiaryType = (typeof beneficiaryTypes)[number];

export const subcategoriesByCategory: Record<CategoryKey, string[]> = {
	health: [
		'medical_research',
		'health_prevention',
		'patient_care',
		'mental_health',
		'sexual_reproductive_health',
		'eye_health',
		'health_facilities',
		'cancer',
		'rare_diseases',
		'neurological_health',
		'neurodevelopment',
		'disability',
		'other_diseases',
	],
	environment: [
		'animal_protection',
		'aquatic_ecosystems',
		'ecosystem_conservation',
		'reforestation',
		'environmental_education',
		'recycling_waste',
	],
	education: [
		'school_education',
		'educational_leisure',
		'digital_divide',
		'job_insertion_entrepreneurship',
		'language_culture',
		'bullying_cyberbullying',
	],
	habitat: ['housing_urban_development', 'sports', 'art_culture', 'elderly_care', 'christmas'],
	feeding: ['community_kitchens', 'food_banks', 'food_waste', 'malnutrition', 'food_security'],
	humanRights: ['gender_equality', 'migration_refuge', 'child_protection', 'lgbtiq_rights'],
	emergency: ['natural_disasters', 'humanitarian_aid', 'health_emergency'],
	basicNeeds: ['energy_poverty', 'water_sanitation', 'renewable_energy'],
};
